import { render, staticRenderFns } from "./salairePersonnel.vue?vue&type=template&id=4a5d12a2&"
import script from "./salairePersonnel.vue?vue&type=script&lang=js&"
export * from "./salairePersonnel.vue?vue&type=script&lang=js&"
import style0 from "./salairePersonnel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports